module.exports = __webpack_public_path__ + "img/square.5578113a.svg";